import React, { useEffect } from 'react';
import { currentUserSelector } from '../../ducks/user.duck';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';

import css from './RenderEmailVerification.module.css';
import { isUserAuthenticated } from '../../ducks/auth.duck';
import { isUserEmailVerified } from '../../util/dataExtractor';
import { useIntl } from 'react-intl';

function RenderEmailVerification(props) {

  const history = useHistory();
  const intl = useIntl()

  const banner1Message = intl.formatMessage({ id: 'ModalMissingInformation.verifyEmailText1' });
  const banner2Message = intl.formatMessage({ id: 'ModalMissingInformation.verifyEmailText2' });
  // const banner3Message = intl.formatMessage({ id: 'ModalMissingInformation.verifyEmailText3' });
  const currentUser = useSelector(currentUserSelector);
  const isAuthenticated = useSelector(isUserAuthenticated);

  if (isUserEmailVerified(currentUser) || !isAuthenticated) {
    return <></>;
  }

  const onRedirectToAccountSettings = () => {
    history.push(createResourceLocatorString('ContactDetailsPage', routeConfiguration(), {}, {}));
  };

  return (
    <div className={css.importantNote}>
      {banner1Message}{' '}
      <span role="button" className={css.verifyEmail} onClick={onRedirectToAccountSettings}>
        {banner2Message}
      </span>{' '}
      {/* {banner3Message} */}
    </div>
  );
}

export default RenderEmailVerification;
